import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dev-func-host]',
    standalone: false
})
export class DevFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}